// Auth Event Names
export const AUTH_EVENTS = {
  LOGIN: 'user_logged_in',
  LOGOUT: 'user_logged_out',
  LOGIN_FAILED: 'user_login_failed',
  SIGNUP: 'user_signed_up',
  PASSWORD_RESET_REQUESTED: 'password_reset_requested',
} as const;

// Auth Event Properties
export interface AuthLoginProperties {
  user_id: string;
  email: string;
  success: boolean;
}

export interface AuthLogoutProperties {
  user_id: string;
  session_duration: number; // how long they were logged in
  name?: string; // User's full name
  email?: string; // User's email
}

export interface AuthLoginFailedProperties {
  email: string;
  error_type: 'invalid_credentials' | 'account_locked' | 'unverified_email' | 'other';
  error_message: string;
}

export interface AuthSignupProperties {
  user_id: string;
  email: string;
  signup_method: 'email' | 'google' | 'github';
}

export interface AuthPasswordResetProperties {
  user_id?: string; // might not have if user isn't logged in
  email: string;
  success: boolean;
  error_message?: string;
}
